import Vue from 'vue'
import Router from 'vue-router'
import Layout from "@/layout/index.vue";

Vue.use(Router)

export const constantRoutes = [
    {
        path: '/redirect',
        component: Layout,
        hidden: true,
        children: [
            {
                path: '/redirect/:path(.*)',
                component: () => import('@/views/redirect/index')
            }
        ]
    },
    {
        path: '/login',
        component: () => import('@/views/login/index'),
        hidden: true
    },
    {
        path: '/simulateLogin',
        component: () => import('@/views/login/simulate.vue'),
        hidden: true
    },
    {
        path: '/auth-redirect',
        component: () => import('@/views/login/auth-redirect'),
        hidden: true
    },{
        path: '/userProtocol',
        component: () => import('@/views/user/userProtocol.vue'),
        hidden: true
    },{
        path: '/yinsi',
        component: () => import('@/views/user/yinsi.vue'),
        hidden: true
    },{
        path: '/infoEdit',
        component: Layout,
        children: [{
            path: '/infoEdit',
            component: () => import('@/views/user/infoEdit.vue'),
            meta: {
                showHead: false
            }
        }],
        hidden: true
    },{
        path: '/incomeDetails',
        component: Layout,
        children: [{
            path: '/incomeDetails',
            component: () => import('@/views/user/incomeDetails.vue'),
            meta: {
                showHead: false
            }
        }],
        hidden: true
    },
    {
        path: '/member',
        component: Layout,
        children: [{
            path: '/member',
            component: () => import('@/views/publish/member.vue'),
            meta: {
                showHead: false
            }
        }],
        hidden: true
    },
    {
        path: '/operation',
        component: Layout,
        children: [{
            path: '/operation',
            component: () => import('@/views/publish/operation.vue'),
            meta: {
                showHead: false
            }
        }],
        hidden: true
    },
    {
        path: '/register',
        redirect: '/register/index',
        component: Layout,
        hidden: true,
        children: [{
            path: 'index',
            component: () => import('@/views/register/index.vue'),
            meta: {
                showHead: false
            }
        }]
    },
    {
        path: '/chat',
        redirect: '/chat/index',
        component: Layout,
        hidden: true,
        children: [{
            path: 'index',
            component: () => import('@/views/chat/index.vue'),
            meta: {
                showHead: false
            }
        }]
    },
    {
        path: '/',
        component: Layout,
        hidden: true,
        redirect: '/publish/discuss' // 将根路径重定向到/home
    },
]

export const asyncRoutes = [
    {
        path: '/publish',
        redirect: '/publish/discuss',
        name: 'Publish',
        component: Layout,
        meta: {
            title: '帖子管理'
        },
        alwaysShow: false,
        children: [
            {
                path: 'discuss',
                name: 'PublishDiscuss',
                component: () => import('@/views/publish/discuss.vue'),
                meta: {
                    title: '帖子管理',
                    activeMenu: '/publish/discuss'
                }
            }
        ]
    },
    {
        path: '/setting',
        redirect: '/setting/setting',
        name: 'Setting',
        component: Layout,
        meta: {
            title: '圈子设置',
            roles: ['*', 'client.cir-circle.add']
        },
        alwaysShow: false,
        children: [
            {
                path: 'setting',
                name: 'PublishSetting',
                component: () => import('@/views/publish/setting.vue'),
                meta: {
                    title: '圈子设置',
                    activeMenu: '/setting/setting'
                }
            }
        ]
    },
    {
        path: '/comment',
        redirect: '/comment/index',
        name: 'Comment',
        component: Layout,
        meta: {
            title: '评论管理',
            roles: ['*', 'client.cir-post-comment.list']
        },
        alwaysShow: false,
        children: [
            {
                path: 'index',
                name: 'CommentManagement',
                component: () => import('@/views/comment/index.vue'),
                meta: {
                    title: '评论管理',
                    activeMenu: '/comment/index',
                    roles: ['*', 'client.cir-post-comment.list']
                }
            }
        ]
    },
    {
        path: '/blacklist',
        redirect: '/blacklist/index',
        name: 'Blacklist',
        component: Layout,
        meta: {
            title: '拉黑管理',
            roles: ['*', 'client.black-list.index']
        },
        alwaysShow: false,
        children: [
            {
                path: 'index',
                name: 'BlacklistManagement',
                component: () => import('@/views/blacklist/index.vue'),
                meta: {
                    title: '拉黑管理',
                    activeMenu: '/blacklist/index',
                    roles: ['*', 'client.black-list.index']
                }
            }
        ]
    },
    {
        path: '/purchase',
        redirect: '/purchase/index',
        name: 'Purchase',
        component: Layout,
        meta: {
            title: '我的购买',
            roles: ['*', 'client.purchase.index']
        },
        alwaysShow: false,
        children: [
            {
                path: 'index',
                name: 'MyPurchase',
                component: () => import('@/views/purchase/index.vue'),
                meta: {
                    title: '我的购买',
                    activeMenu: '/purchase/index',
                    roles: ['*', 'client.purchase.index']
                }
            }
        ]
    },
    {
        path: '/private',
        redirect: '/private/message',
        name: 'Private',
        component: Layout,
        meta: {
            title: '私信管理',
            roles: ['*', 'client.purchase.index']
        },
        alwaysShow: false,
        children: [
            {
                path: 'message',
                name: 'PrivateMessage',
                component: () => import('@/views/private/message.vue'),
                meta: {
                    title: '私信管理',
                    activeMenu: '/private/message',
                    roles: ['*', 'client.purchase.index']
                }
            }
        ]
    }
]
const createRouter = () =>
    new Router({
        // mode: 'history', // require service support
        scrollBehavior: () => ({ y: 0 }),
        routes: constantRoutes
    })


const router = createRouter()

export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
}

export default router
